import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GENERATE_LOGIN_OTP } from "../../redux/constant";
import { toast } from "react-toastify";
import Input from "../../lib/ui/Input/Input";

const ILogin = ({ setOtpStage = () => {} }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const otpSendSuccessfully = useSelector((state) => state?.user.generateOTP);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("otpSendSuccessfully", otpSendSuccessfully);
    if (otpSendSuccessfully) setOtpStage(true);
  }, [otpSendSuccessfully]);

  const handlePhoneNumberChange = (event) => {
    const inputValue = event.target.value;
    // Allow only numbers and limit to 10 digits
    const sanitizedValue = inputValue.replace(/[^0-9]/g, "").slice(0, 10);
    setPhoneNumber(sanitizedValue);
  };

  const handleGenerateOtp = () => {
    // Here you would typically make an API call to your backend
    // to generate an OTP and send it to the provided phone number.
    // For this example, we'll simulate a successful OTP generation.
    if (phoneNumber.length === 10) {
      localStorage.setItem("user_mobile", phoneNumber);
      dispatch({ type: GENERATE_LOGIN_OTP, payload: phoneNumber });
    } else {
      toast.warning("Please enter a valid 10-digit phone number.");
    }
  };

  return (
    <>
      <h1>Login</h1>
      <Input
        required
        type="tel"
        className="loginInput"
        id="phoneNumber"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        placeholder="Enter 10-digit phone number"
      />
      <br></br>
      <button onClick={handleGenerateOtp} className="full-btn btn">
        Continue
      </button>
    </>
  );
};

export default ILogin;
